import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './Dashboard.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from './Navbar';

const Dashboard = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [error, setError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentUser, setCurrentUser] = useState(null); 
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem('token');
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(res.data);
        setFilteredUsers(res.data);
      } catch (err) {
        setError('Failed to fetch users');
        console.error(err);
      }
    };

    const fetchCurrentUser = async () => {
      const token = localStorage.getItem('token');
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/auth/me`, { 
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCurrentUser(res.data);
      } catch (err) {
        setError('Failed to fetch current user');
        console.error(err);
      }
    };

    fetchUsers();
    fetchCurrentUser();
  }, []);

  useEffect(() => {
    const result = users.filter(user =>
      user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredUsers(result);
  }, [searchQuery, users]);

  const handleEdit = (userId) => {
    navigate(`/edit-user/${userId}`);
  };

  const handleAddUser = () => {
    navigate('/add-user');
  };

  const handleDelete = async (userId) => {
    const token = localStorage.getItem('token');
    try {
      await axios.delete(`${process.env.REACT_APP_URL}/users/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUsers(users.filter(user => user.id !== userId));
    } catch (err) {
      setError('Failed to delete user');
      console.error(err);
    }
  };

  const getRoleClass = (role) => {
    switch (role) {
      case 'admin':
        return styles.admin;
      case 'super admin':
        return styles.superAdmin;
      case 'basic user':
        return styles.basicUser;
      default:
        return '';
    }
  };

  return (
    <>
    <div className="App">
      <Navbar />
      <div className="allContent">
        <Container fluid>
          <Row className="justify-content-center">
            <Col xs="12" lg="12" className='mt-1'>
              <Row className="justify-content-center">
                <Col xs="6" lg="6" className='align-self-center'>
                  <h1 className=''>User Dashboard</h1>
                  <p>Manage your team and their permissions here.</p>
                </Col>
                <Col xs="6" lg="6" className='align-self-start text-end mt-2'>
                  <div className={styles.currentUser}>
                    {currentUser ? (
                      <p>Welcome, {currentUser.username}!</p>
                    ) : (
                      <p>Loading user...</p>
                    )}
                  </div>
                </Col>
              </Row>
              <div className='bx_dash'>
              <Row className="justify-content-center">
                <Col xs="12" md="6" className='align-self-center'>
                  <h2 className='text-start'>All Users: <span className={styles.allUsers}>{filteredUsers.length}</span></h2>
                </Col>
                <Col xs="12" md="4" className='align-self-center'>
                  <div className='ser_inp'>
                    <input
                      type="text"
                      placeholder="Search users..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className={styles.searchInput}
                    />
                  </div>
                </Col>
                <Col xs="12" md="2" className='align-self-center'>
                  <button onClick={handleAddUser} className='add_us_btn w-100'>Add User</button>
                </Col>
              </Row>
              </div>
              <div className='userTable'>
                {error && <p className={styles.error}>{error}</p>}
                <table className=''>
                  <thead>
                    <tr>
                      <th>Username</th>
                      <th>Role</th>
                      {/* <th>Permissions</th> */}
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.map((user) => (
                      <tr key={user.id}>
                        <td>
                          <div className={styles.userInfo}>
                            <span className={styles.username}>{user.username}</span>
                            <span className={styles.email}>{user.email}</span>
                          </div>
                        </td>
                        <td>  
                          <span key={user.role} className={`${styles.role} ${getRoleClass(user.role)}`}>
                              {user.role}
                          </span>
                      </td>
                        {/* <td>{user.permissions.join(', ')}</td> */}
                        <td>
                          <button className={styles.editButton} onClick={() => handleEdit(user.id)}>Edit</button>
                          <button className={styles.deleteButton} onClick={() => handleDelete(user.id)}>Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    </>
  );
};

export default Dashboard;
